import React from "react";
import "rc-switch/assets/index.css";
import { connect } from "react-redux";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import axios from "../../axios-atis";

import { Button, Col, FormControl, Row } from "react-bootstrap";
import Section from "./Section";
import { isA, isReporter } from "../../store/utility";
import Switch from "rc-switch";
//import { ReactCSSTransitionGroup } from "react-addons-css-transition-group";
import Loader from "react-loader-spinner";

class Sections extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      backupData: null,
      rowId: null,
      editingId: null,
      addSection: false,
      displayDeleted: false,
      selectedCompany: "all",
    };
  }

  //LifeCycle
  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        data: nextProps.data,
        backupData: nextProps.data,
      });
    }
  }

  //BackEnd Call
  addSectionHandler = (event) => {
    event.preventDefault();
    var _state = this.state;
    _state.addSection = true;
    this.setState(_state);
  };

  hideSectionHandler = (event) => {
    event.preventDefault();
    var _state = this.state;
    _state.addSection = false;
    this.setState(_state);
  };

  //UI methods
  disableOthersEditing = (id) => {
    this.setState({ editingId: id });
    this.forceUpdate();
  };

  saveOrUpdate = (section) => {
    this.props.saveOrUpdate(section);
    var _state = this.state;
    _state.addSection = false;
    _state.editingId = null;
    this.setState(_state);
  };

  changeDisplayInputHandler = (value) => {
    this.setState({ displayDeleted: value });
  };

  buildRows = (editingId) => {
    const { selectedCompany, displayDeleted } = this.state;
    let { data } = this.props;
    if ( selectedCompany !== "all" ) {
      //console.log( selectedCompany);
      data = data.filter((c) =>  c.company === selectedCompany)
    }
    
    var companySections = [];

    for (var i = 0; i < data.length; i++) {
      var element = data[i];
      if (
        displayDeleted ||
        (!displayDeleted && element.enabled)
      ) {
        var objectAlreadyExists = false;
        for (var j = 0; j < companySections.length; j++) {
          if (companySections[j].company === element.company) {
            companySections[j].sections.push(element);
            objectAlreadyExists = true;
            break;
          }
        }
        if (!objectAlreadyExists) {
          var sections = [];
          sections.push(element);
          companySections.push({
            company: element.company,
            sections: sections,
          });
        }
      }
    }
    var rows = [];
    companySections.sort((a, b) => {
      if (a == null || a.company == null) {
        return -1;
      } else if (b == null || b.company == null) {
        return 1;
      } else {
        return a.company.trim().localeCompare(b.company.trim(), "fr-FR");
      }
    });

    for (var k = 0; k < companySections.length; k++) {
      if (companySections.length > 1) {
        rows.push(
          <h5 key={k} style={{ borderBottom: "1px solid #efefef" }}>
            {companySections[k].company}
          </h5>
        );
      }
      var l = 0;
      var nbCols = 0;
      companySections[k].sections.sort((a, b) => {
        if (a.enabled == null) {
          return -1;
        } else if (b.enabled == null) {
          return 1;
        } else {
          if (a.enabled === b.enabled) {
            return a.label.trim().localeCompare(b.label.trim(), "fr-FR");
          } else if (a.enabled) {
            return -1;
          } else {
            return 1;
          }
        }
      });

      let nbSections = companySections[k].sections.length;
      while (nbCols < nbSections) {
        rows.push(
          <Row key={(k + 1) * 1024 + l}>
            <Col sm={4}>
              {l < nbSections ? (
                <Section
                  data={companySections[k].sections[l]}
                  editing={editingId === companySections[k].sections[l].id}
                  disableOthersEditing={this.disableOthersEditing}
                  saveOrUpdate={(section) => this.saveOrUpdate(section)}
                />
              ) : null}
            </Col>
            <Col sm={4}>
              {l + 1 < nbSections ? (
                <Section
                  data={companySections[k].sections[l + 1]}
                  editing={editingId === companySections[k].sections[l + 1].id}
                  disableOthersEditing={this.disableOthersEditing}
                  saveOrUpdate={(section) => this.saveOrUpdate(section)}
                />
              ) : null}
            </Col>
            <Col sm={4}>
              {l + 2 < nbSections ? (
                <Section
                  data={companySections[k].sections[l + 2]}
                  editing={editingId === companySections[k].sections[l + 2].id}
                  disableOthersEditing={this.disableOthersEditing}
                  saveOrUpdate={(section) => this.saveOrUpdate(section)}
                />
              ) : null}
            </Col>
          </Row>
        );
        nbCols += l + 2 < nbSections - 1 ? 3 : l + 1 < nbSections - 1 ? 2 : 1;
        if (l + 3 < nbSections) {
          l += 3;
        } else {
          l += nbSections - l;
        }
      }
    }

    return rows;
  };
  getSections2(company) {
    if (null !== company.sections) 
      return company.sections.map(function(item, index) {
          return (
            <option key={index} value={item == null ? "" : item.name}>
              {item == null ? "" : item.label || item.name}
            </option>
          );
        });
            
  }
  getSections = (companies) => {
    let rows = [];
    if (companies !== null) {
      for (const company of companies) {
        if (company.sections.length>0) {
          rows.push(
            <optgroup label={company.name}>
              {this.getSections2(company)}
            </optgroup>
          )
        }
      }
    }
    
    return rows;
  }
  changeCompany = (event) => {
    this.setState({selectedCompany: event.target.value});
  }

  render() {
    const { data, company, companies } = this.props;
    if (this.props.data === null || this.props.company === null) {
      return (<div align="center">
        <Loader type="ThreeDots" color="#00BFFF" height="100" width="100" />
      </div>);
    }
    const { editingId, displayDeleted } = this.state;
    const rows = this.buildRows(editingId);
    var newSection = {
      id: null,
      label: "",
      enabled: true,
      address: {
        id: null,
        line1: null,
        line2: null,
        line3: null,
        postCode: null,
        locality: null,
      },
    };
    if (!isA() && !isReporter()) {
      newSection.company = this.props.companies[0];
    }
    return (
      <div>
        { isA() || isReporter() ? (
        <Row style={{ paddingBottom: "20px" }}>
          <Col sm={12}>
            <FormControl componentClass="select" onChange={this.changeCompany} value={this.state.selectedCompany}>
              <option value="all">Afficher tout</option>
              {null !==  companies ? companies.map(function(item, index) {
              return (
                <option key={index} value={item == null ? "all" : item.name}>
                  {item == null ? "" : item.label || item.name}
                </option>
              );
            })
            : ""}
            </FormControl>
          </Col>
        </Row>) : null}
        <Row>
          <Col xsHidden sm={12} style={{ display: 'flex', alignItems: 'center', justifyItems: 'flex-end', flexDirection: 'row-reverse' }}>
            <Button
              bsStyle="primary"
              bsSize="sm"
              className="pull-right"
              style={{ marginLeft: '10px' }}
              onClick={(event) => this.addSectionHandler(event)}
            >
              <span className="fa fa-plus" />
              &nbsp;Nouveau site
            </Button>
            <div className="pull-right">
              Afficher les sites supprimés{" "}
              <Switch
                checked={displayDeleted}
                onChange={(event) => this.changeDisplayInputHandler(event)}
              />
            </div>
          </Col>
          <Col smHidden mdHidden lgHidden  xs={12}>
            Afficher les sites supprimés{" "}
            <Switch
              checked={displayDeleted}
              onChange={(event) => this.changeDisplayInputHandler(event)}
            />
          </Col>
          <Col smHidden mdHidden lgHidden xs={12}>
            <Button
              bsStyle="primary"
              bsSize="sm"
              className="pull-right"
              style={{ marginLeft: '10px' }}
              onClick={(event) => this.addSectionHandler(event)}
            >
              <span className="fa fa-plus" />
              &nbsp;Nouveau site
            </Button>
          </Col>
        </Row>
        {this.state.addSection ? (
          <Row>
            <Col sm={3} />
            <Col sm={6}>
              <Section
                data={newSection}
                editing={true}
                companies={this.props.companies}
                company={this.props.company}
                disableOthersEditing={this.disableOthersEditing}
                saveOrUpdate={(section) => this.saveOrUpdate(section)}
                hideSection={(event) => this.hideSectionHandler(event)}
              />
            </Col>
            <Col sm={3} />
          </Row>
        ) : null}
        {rows}
      </div>
    );
  }
}
//export default Sections;

const mapStateToProps = (state) => {
  return {
    loading: state.companies,
    isAuthenticated: state.auth.token !== null,
    companies: state.company.companies,
  };
};

export default connect(mapStateToProps)(withErrorHandler(Sections, axios));



// WEBPACK FOOTER //
// ./src/containers/Section/Sections.js